import React, { useEffect, useState } from "react";
import { getPhase } from "helpers/rsc";
import { usePrevious } from "./common"
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import SvgMirs from "components/presentation/SvgMirs";

export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let competitorPlace = competitor?.cp_code ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} /> : ''
    let pool = getPhase(competitor?.cp_prev_unit?.code).match(/^GP./);
    pool = pool ? pool[0].substring(2) : pool

    return (
        <div className='  d-flex flex-row justify-content-start'>
            <div className=''>{competitor?.cp_code === 'NOCOMP' ? competitorPlace : pool ? `${competitor?.cp_prev_value}` : ''}</div>
        </div>
    )
}

export function Score(props) {
    const irm = props.showIRM && <div className='score-cards pe-1'><b>{`${props?.cp_irm}`}</b></div>
    const pso = props?.periods?.find(p => p?.p_code === 'PSO');
    let resultPso
    if (pso && props?.participant?.code === pso?.away?.participant?.code) {
        resultPso = pso?.away?.periodScore ? `(${pso?.away?.periodScore})` : '';
    } else if (pso) {
        resultPso = pso?.home?.periodScore ? `(${pso?.home?.periodScore})` : '';
    }
    const resultItem = props?.resultItem;
    /**
                   "sortOrder": 1,
                      "itemType": "T",
                      "bib": 0,
                      "resultType": "POINTS",
                      "resultRank": 0,
                      "resultIrm": "",
                      "resultWLT": " ",
                      "resultData": "45"
     */
    const winner = resultItem?.resultWLT === 'W' && <div className='score-winner'><SvgMirs className='mirsIcon score-winner' title='HeaderWinner' code='circle-check' /></div>
    const [isLoading, setLoading] = useState(false);
    const result = resultItem?.resultData; //competitor.cp_result );
    const prevResult = usePrevious({ result });

    //console.log('COMPONENT PREV-USE: ' + prevResult)
    function loadingTime() {
        return new Promise((resolve) => setTimeout(resolve, 4000));
    }
    useEffect(() => {
        if (isLoading) {
            loadingTime().then(() => {
                setLoading(false);
            });
        }
    }, [isLoading]);


    useEffect(() => {
        if (prevResult && (prevResult !== result)) {
            setLoading(true)
        }

    }, [result])


    return (
        <div className='score-result-container  d-flex flex-row justify-content-end'>
            {irm}
            <div className={`score-result text-end fw-bold ${isLoading ? 'score-result-update' : ''}`}>{result}{resultPso}</div>
        </div>
    )
}

